// ROOT STORE
export const ROOT_LOGOUT = 'LOGOUT'
export const ROOT_SET_TOKEN = 'SET_TOKEN'
export const ROOT_CHECK_TOKEN = 'CHECK_TOKEN'
export const ROOT_SET_INIT = 'SET_INIT'
export const ROOT_SET_LOGGED_IN = 'SET_LOGGED_IN'
export const ROOT_LOADING = 'LOADING'
export const ROOT_PAGE_LOADING = 'PAGE_LOADNG'
export const ROOT_SET_ERROR = 'SET_ERROR'
export const ROOT_CLEAR_ERROR = 'CLEAR_ERROR'
export const ROOT_SET_SNACKBAR = 'SET_SNACKBAR'
export const ROOT_CLEAR_SNACKBAR = 'CLEAR_SNACKBAR'
export const ROOT_SET_CHATBADGE = 'SET_CHATBADGE'
export const ROOT_RESET_CHATBADGE = 'RESET_CHATBADGE'
export const ROOT_SET_MATCH_EVALUATION = 'SET_MATCH_EVALUATION'
export const ROOT_SET_OFFICE_DATA = 'SET_OFFICE_DATA'
// Login_register store
export const AUTH_RESET = 'AUTH_RESET'
export const AUTH_SET_LOGIN_EMAIL = 'AUTH_SET_LOGIN_EMAIL'
export const AUTH_SHOW_VERIFY_LINK = 'AUTH_SHOW_VERIFY_LINK'
export const AUTH_WAS_VERIFY_EMAIL_SEND = 'AUTH_WAS_VERIFY_EMAIL_SEND'
export const AUTH_WAS_PASSWORD_EMAIL_SEND = 'AUTH_WAS_PASSWORD_EMAIL_SEND'
// Changelog store
export const CHANGELOG_RESET = 'CHANGELOG_RESET'
export const CHANGELOG_SET_CHANGELOGS = 'CHANGELOG_SET_CHANGELOGS'
export const CHANGELOG_SET_CACHE_TIME = 'CHANGELOG_SET_CACHE_TIME'
// Manager store
export const MANAGER_RESET = 'MANAGER_RESET'
export const MANAGER_SET_NAME = 'MANAGER_SET_NAME'
export const MANAGER_SET_ID = 'MANAGER_SET_ID'
export const MANAGER_SET_IMAGE_ID = 'MANAGER_SET_IMAGE_ID'
export const MANAGER_SINCE = 'MANAGER_SINCE'
// TEAM store
export const TEAM_RESET = 'TEAM_RESET'
export const TEAM_SET_TEAM_NAME = 'TEAM_SET_TEAM_NAME'
export const TEAM_SET_TEAM_LOGO = 'TEAM_SET_TEAM_LOGO'
export const TEAM_SET_LIGA = 'TEAM_SET_LIGA'
export const TEAM_SET_PLAYERS = 'TEAM_SET_PLAYERS'
export const TEAM_SET_WURFZAHL = 'TEAM_SET_WURFZAHL'
export const TEAM_SET_TRAINING = 'TEAM_SET_TRAINING'
export const TEAM_SET_TRAININGSLAGERS = 'TEAM_SET_TRAININGSLAGERS'
export const TEAM_SET_TRAININGSLAGER = 'TEAM_SET_TRAININGSLAGER'
export const TEAM_SET_AUFSTELLUNG = 'TEAM_SET_AUFSTELLUNG'
export const TEAM_SET_CREATED_NEW_PLAYERS = 'TEAM_SET_CREATED_NEW_PLAYERS'
export const TEAM_SET_CREATED_NEW_PLAYERS_COUNTER = 'TEAM_SET_CREATED_NEW_PLAYERS_COUNTER'
// SAISON store
export const SAISON_RESET = 'SAISON_RESET'
export const SAISON_SET_SAISON = 'SAISON_SET_SAISON'
export const SAISON_SET_MODAL_OPEN = 'SAISON_SET_MODAL_OPEN'
export const SAISON_SET_CURRENTMATCHDAY = 'SAISON_SET_CURRENTMATCHDAY'
export const SAISON_SET_LIGA = 'SAISON_SET_LIGA'
export const SAISON_SET_LIGEN = 'SAISON_SET_LIGEN'
export const SAISON_SET_LOGOS = 'SAISON_SET_LOGOS'
export const SAISON_SET_NEW_TEAM_LOGO = 'SAISON_SET_NEW_TEAM_LOGO'
export const SAISON_SET_LOGO_CACHE_TIME = 'SAISON_SET_LOGO_CACHE_TIME'
export const SAISON_SET_LEAGUE_CACHE_TIME = 'SAISON_SET_LEAGUE_CACHE_TIME'
export const SAISON_SET_AUSWERTUNG = 'SAISON_SET_AUSWERTUNG'
export const SAISON_SET_CACHE = 'SAISON_SET_CACHE'

// MONEY store
export const MONEY_RESET = 'MONEY_RESET'
export const MONEY_SET_ALL_SPONSOREN = 'MONEY_SET_ALL_SPONSOREN'
export const MONEY_SET_SPONSOR = 'MONEY_SET_SPONSOR'
export const MONEY_SET_GIRO = 'MONEY_SET_GIRO'
export const MONEY_SET_SPAR = 'MONEY_SET_SPAR'
export const MONEY_SET_FINANZEN = 'MONEY_SET_FINANZEN'
// FAHRZEUG
export const FAHRZEUG_RESET = 'FAHRZEUG_RESET'
export const FAHRZEUG_SET_MY_FAHRZEUG = 'FAHRZEUG_SET_MY_FAHRZEUG'
export const FAHRZEUG_SET_FAHRZEUGE = 'FAHRZEUG_SET_FAHRZEUGE'
export const FAHRZEUG_SET_ZUSTAND = 'FAHRZEUG_SET_ZUSTAND'
export const FAHRZEUG_SET_AUSBAU = 'FAHRZEUG_SET_AUSBAU'
export const FAHRZEUG_SET_CACHE_TIME = 'FAHRZEUG_SET_CACHE_TIME'
// KEGELBAHN
export const KEGELBAHN_RESET = 'KEGELBAHN_RESET'
export const KEGELBAHN_SET_MY_KEGELBAHN = 'KEGELBAHN_SET_MY_KEGELBAHN'
export const KEGELBAHN_SET_KEGELBAHNEN = 'KEGELBAHN_SET_KEGELBAHNEN'
export const KEGELBAHN_SET_ZUSTAND = 'KEGELBAHN_SET_ZUSTAND'
export const KEGELBAHN_SET_AUSBAU = 'KEGELBAHN_SET_AUSBAU'
export const KEGELBAHN_SET_CACHE_TIME = 'KEGELBAHN_SET_CACHE_TIME'
// CHAT
export const CHAT_RESET = 'CHAT_RESET'
export const CHAT_SEND_MESSAGE = 'CHAT_SEND_MESSAGE'
export const CHAT_SET_CHAT = 'CHAT_SET_CHAT'
export const CHAT_SET_CONNECTION_STATUS = 'CHAT_SET_CONNECTION_STATUS'
export const CHAT_SET_NEW_MESSAGE = 'CHAT_SET_NEW_MESSAGE'
export const CHAT_RESET_NEW_MESSAGE = 'CHAT_RESET_NEW_MESSAGE'
export const CHAT_SET_NEW_MESSAGE_COUNTER = 'CHAT_SET_NEW_MESSAGE_COUNTER'
export const CHAT_RESET_NEW_MESSAGE_COUNTER = 'CHAT_RESET_NEW_MESSAGE_COUNTER'
